import { htmlToPlainText } from '@/utils/htmlSanitizer';

/**
 * The note under a manager assessment question is typed as plain text, but it is stored as an
 * employee note, whose content is HTML (the profile edits the same note with `RichText`). These two
 * conversions are the bridge.
 *
 * The bridge is lossy in one direction only: a note given rich formatting from the profile (bold,
 * lists, links) reads here as its bare lines, and if its author then changes the text from the
 * assessment, the note is saved back as plain paragraphs and that formatting is gone. Leaving the
 * field untouched never rewrites the note.
 */

const HTML_ESCAPES: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
};

const escapeHtml = (text: string): string =>
    text.replace(/[&<>"]/g, (character) => HTML_ESCAPES[character]);

/** Every line becomes its own paragraph, blank lines included, so the text reads back unchanged. */
export const plainTextToNoteHtml = (text: string): string =>
    text
        .split('\n')
        .map((line) => `<p>${escapeHtml(line)}</p>`)
        .join('');

export const noteHtmlToPlainText = (html: string): string =>
    // Every block closes with a break, so the last one is the end of the text, not an empty line.
    htmlToPlainText(html, '\n').replace(/\n$/, '');
